/*=========================================================================================
  File Name: moduleNotify.js
  Description: Notify Module
==========================================================================================*/


import state from './moduleNotifyState.js'
import mutations from './moduleNotifyMutations.js'
import actions from './moduleNotifyActions.js'
import getters from './moduleNotifyGetters.js'

export default {
  notifyTypeList: [
    {value:'0', label:'Сообщение', color:'success', tag:'message'},
    {value:'1', label:'Предупреждение', color:'warning', tag:'warning'},
    {value:'2', label:'Ошибка', color:'danger', tag:'danger'},
  ],
  notifyStateList: [
    {value:'0', label:'Новое', color:'success', tag:'new'},
    {value:'1', label:'Опубликовано', color:'warning', tag:'public'},
    {value:'2', label:'Прочитано', color:'danger', tag:'readed'},
    {value:'3', label:'Закрыто', color:'danger', tag:'closed'},
  ],

  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
